import { observable } from 'mobx'

export default class BookPrefStore {
  @observable books = []
  @observable book = []
  @observable created = false
  @observable bookPrefDatasetId = ''

  updateBooks(data) {
    this.books = data
  }

  updateBook(data) {
    this.book = data
  }

  updateCreated() {
    this.created = true
  }

  updateBookProgress(max) {
    this.book.maxPage = max
    this.book.percentRead = parseInt(
      100 * (parseInt(max, 10) / parseInt(this.book.totalPages, 10)),
      10
    )
    var bookIndex = this.books.findIndex(obj => obj.id === this.book.id)
    this.books[bookIndex]['maxPage'] = this.book.maxPage
    this.books[bookIndex]['percentRead'] = this.book.percentRead
  }
}



// WEBPACK FOOTER //
// ./src/stores/BookPrefStore.js